import React, { PropsWithChildren } from 'react'
import {
  Dialog as MUIDialog,
  DialogProps,
  DialogTitle,
  DialogTitleProps,
  DialogContent,
  DialogContentProps,
  DialogActions,
  DialogActionsProps,
  IconButton,
  ThemeOptions,
  Slide,
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import CloseIcon from '@mui/icons-material/Close'
import styled from '@emotion/styled'
import { colors } from '../../tokens/colors'

const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
  color: ${colors.interactive.primaryEnabled};
`

// eslint-disable-next-line @typescript-eslint/naming-convention, react/display-name
const Transition = React.forwardRef(
  (
    props: TransitionProps & {
      children: React.ReactElement
    },
    ref: React.Ref<unknown>
  ) => <Slide direction='up' ref={ref} {...props} />
)

const Dialog: React.FC<PropsWithChildren & DialogProps> = ({
  children,
  ...props
}) => (
  <MUIDialog {...props} TransitionComponent={Transition} keepMounted>
    <CloseButton
      aria-label='close'
      onClick={(e) => props.onClose?.(e, 'escapeKeyDown')}
    >
      <CloseIcon />
    </CloseButton>
    {children}
  </MUIDialog>
)

export { Dialog, DialogTitle, DialogContent, DialogActions }

export type {
  DialogProps,
  DialogTitleProps,
  DialogContentProps,
  DialogActionsProps,
}

export const dialogThemeOverrides: ThemeOptions['components'] = {
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: '24px',
      },
    },
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        // Default value is `auto`, which clips the labels of any inputs at the
        // top of the content
        overflowY: 'unset',
        padding: '0px 24px 24px',
      },
    },
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: '0px 24px 24px',
      },
    },
  },
  MuiAvatar: {
    styleOverrides: {
      root: {
        color: colors.copy.paragraphDark,
      },
    },
  },
}
